// removed by extract-text-webpack-plugin
module.exports = {"root":"_3oq7mX0j74jliPWVHy2XKA","summary-data":"Yv4DJxFsi2SDf1_jZ2Nfl","completion-rate":"_2Ro9X2VLRw93MQvbTEVpZs","information":"_30YjWOC4bfIjcZJxDQyo56","item-wrapper":"_1zoKNC8Z2ktVz1CMpnX-eG","item":"_28vQBZHhRuRu9KevbJxqaH","audience":"_9flNI7pou4AWiouysB8R8","audience-item":"_2LT0FVCkwMOFcMy3wpEMpH","card":"_3Ut2SIcH1E4b5eRpVz0gY3","short":"_2Pxxg-IsHjPshaR32Q_q5","full-width":"_1egs0HyKLuK79V5Le8clUS","half-width":"_3CZvBDOW8iTTTZtKtTAQXD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/show/overview/overview.scss
// module id = 1625
// module chunks = 0